import { Link } from "react-router-dom";
import { TrialBanner } from "@/components/TrialBanner";
import { NotificationBell } from "@/components/NotificationBell";
import { HelpMenu } from "@/components/HelpMenu";
import { AppSidebar } from "@/components/AppSidebar";
import { SupportChatWidget } from "@/components/SupportChatWidget";
import { OnboardingTour } from "@/components/OnboardingTour";
import { useOnboardingTour } from "@/hooks/useOnboardingTour";
import {
  SidebarProvider,
  SidebarTrigger,
  SidebarInset,
} from "@/components/ui/sidebar";

export default function Layout({ children }: { children: React.ReactNode }) {
  const { showTour, currentStep, completeTour, skipTour, nextStep, prevStep } = useOnboardingTour();

  return (
    <SidebarProvider>
      <OnboardingTour
        open={showTour}
        currentStep={currentStep}
        onNext={nextStep}
        onPrev={prevStep}
        onComplete={completeTour}
        onSkip={skipTour}
      />
      <AppSidebar />
      <SidebarInset>
        {/* Top bar with trigger and notifications */}
        <header className="flex h-14 items-center justify-between border-b border-border bg-card px-4">
          <SidebarTrigger />
          <div className="flex items-center gap-1">
            <HelpMenu />
            <NotificationBell />
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-1 px-4 py-6 sm:px-6 lg:px-8">
          <div className="mb-6">
            <TrialBanner />
          </div>
          {children}
        </main>

        {/* Footer */}
        <footer className="border-t border-border bg-card mt-auto">
          <div className="px-4 py-6 sm:px-6 lg:px-8">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
              <p>© 2026 Quote Send Go. All rights reserved.</p>
              <div className="flex gap-6">
                <Link to="/support" className="hover:text-foreground transition-colors">
                  Support Docs
                </Link>
                <Link to="/terms" className="hover:text-foreground transition-colors">
                  Terms of Service
                </Link>
                <Link to="/privacy" className="hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </footer>
        <SupportChatWidget />
      </SidebarInset>
    </SidebarProvider>
  );
}
